import { h, render, Component } from 'preact'
import { useState, useCallback } from 'preact/hooks'
import { useTrie } from '../hooks/use-trie'
import t from '../i18n'

const TypeAhead = ({items, transform, onSelect }) => {

    const [text, setText] = useState('')
    const [hasFocus, setHasFocus] = useState(false)
    const [selected, setSelected] = useState(0)
    const [trie] = useTrie(items, transform)

    const getResults = useCallback(() => {
        return trie.fuzzy(text, 50).slice(0, 10)
    }, [text, selected])

    const handleKeyPress = (e) => {
        // TODO: handle out of bounds keypresses
        switch(e.key) {
            case "ArrowDown":
                setSelected(selected < getResults().length - 1 ? selected + 1 : selected)
                e.preventDefault()
                break
            case "ArrowUp":
                setSelected(selected > 0 ? selected - 1 : 0)
                e.preventDefault()
                break
            case "Enter":
                const item = getResults().find((r,i) => i === selected)
                selectValue(item.value)
                e.preventDefault()
                break
            case "Escape":
                setText('')
                break
        }
    }

    const handleResultClick = (r,  index) => {
        setSelected(index)
        const value = trie.value(r.value.text)
        if (value) selectValue(value)
    }

    const selectValue = (v) => {
        setText(v.text)
        onSelect(v)
        setHasFocus(false)
    }

    return (
        <div class="nm-type-ahead-container">
            <div class="nm-type-ahead-form">
                <input type="search"
                    value={text}
                    onInput={(e) => { setText(e.target.value); setHasFocus(true) }}
                    onKeyDown={ handleKeyPress }
                    onBlur={() => { setTimeout(() => {setHasFocus(false) }, 1000) }}
                />
            </div>
            { 
                <div class="nm-type-ahead-results">
                    {
                        text.length > 0 && getResults().length === 0 &&
                            <div>{ t("no.results.for") } <b>{text}</b></div>
                    }
                    { hasFocus &&
                        getResults().map((r, i) =>
                            <div class={i === selected && 'selected'} onClick={() => handleResultClick(r,i)}>
                                <span class={`nm-icon icon-${r.value.type}`}></span>
                                { r.value.text }
                            </div>
                        )
                    }
                </div>
            }
        </div>
    )
}

export default TypeAhead
